export default "__VITE_PUBLIC_ASSET__50d75a95__"